import { jsxs, jsx } from "react/jsx-runtime";
const IconLinkBrokenSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M7.054 21.946a4.965 4.965 0 0 1-3.535-1.465c-.945-.943-1.465-2.199-1.465-3.535s.52-2.592 1.465-3.535l3.239-3.24a1 1 0 1 1 1.414 1.415l-3.24 3.24c-.566.566-.878 1.319-.878 2.12s.312 1.555.879 2.121c1.132 1.133 3.109 1.133 4.242 0l3.24-3.239a1 1 0 1 1 1.413 1.414l-3.24 3.24a4.964 4.964 0 0 1-3.534 1.464Zm9.481-7.825a1 1 0 0 1-.707-1.707l3.24-3.238a3.005 3.005 0 0 0 0-4.243 3.007 3.007 0 0 0-4.244 0l-3.238 3.239a1 1 0 1 1-1.414-1.414l3.238-3.24a5.006 5.006 0 0 1 7.071 0 5.008 5.008 0 0 1 0 7.072l-3.239 3.238a.997.997 0 0 1-.707.293ZM5.574 6.587a.997.997 0 0 1-.707-.293L3.453 4.879a1 1 0 1 1 1.414-1.414L6.281 4.88a1 1 0 0 1-.707 1.707ZM3.896 9.494a.994.994 0 0 1-.26-.034l-1.93-.518a1 1 0 0 1 .517-1.931l1.931.517a1 1 0 0 1-.258 1.966ZM8.48 4.908a.999.999 0 0 1-.964-.741l-.518-1.932a1 1 0 0 1 1.932-.517l.517 1.931a1 1 0 0 1-.967 1.26Zm11.36 15.92a.997.997 0 0 1-.707-.293l-1.414-1.415a1 1 0 1 1 1.414-1.414l1.414 1.415a1 1 0 0 1-.707 1.707Zm2.197-3.805a.994.994 0 0 1-.26-.034l-1.931-.517a1 1 0 0 1 .517-1.932l1.932.518a1 1 0 0 1-.258 1.965Zm-6.002 6a.999.999 0 0 1-.965-.74l-.517-1.932a1 1 0 0 1 1.931-.518l.518 1.932a1 1 0 0 1-.967 1.258Z" })
    ]
  }
);
export {
  IconLinkBrokenSvg
};
